module.exports = __webpack_public_path__ + "img/symbol_10.35dbc94d.png";